import { UpdatePatientInfo } from 'domain/usecases/patient/update-patient-info'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteUpdatePatientInfo implements UpdatePatientInfo {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  update(params: UpdatePatientInfo.Params): Promise<UpdatePatientInfo.Model> {
    return this.patientRepository.updatePatientInfo(params)
  }
}
